import styled from 'styled-components';

export const Tag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: ${(p) => p.theme.step[0]}px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: ${(p) => p.theme.color.bg[2]};
  color: ${(p) => p.theme.color.text[2]};
  border: 1px solid ${(p) => p.theme.color.border.soft};
`;
